<template>
  <div class="layout-container">
    <div class="main-background"></div>
    <div id="container-fluid">
      <NavBar :class="{Scrolled }" />
      <particlesBackground />
      <div class="content-container">
        <router-view></router-view>
      </div>
      <bottomBar />
      <LoadingSpinner />
    </div>
  </div>
</template>

<script>
import NavBar from "./navBar";
import particlesBackground from "./particlesBackground";
import LoadingSpinner from "./loading/LoadingSpinner";
import bottomBar from "./bottomBar";

export default {
  components: {
    NavBar,
    particlesBackground,
    bottomBar,
    LoadingSpinner,
  },
  data: function () {
    return {
      Scrolled: false,
    };
  },

  mounted: function () {
    this.registerScrollListener();
  },

  methods: {
    registerScrollListener: function () {
      document.addEventListener("scroll", this.__scrollEventHandler);
    },

    __scrollEventHandler: function () {
      this.Scrolled =
        document.documentElement.scrollTop &&
        document.documentElement.scrollTop > 5
          ? true
          : false;
    },
  },

  beforeDestroy: function () {
    document.removeEventListener("scroll", this.__scrollEventHandler);
  },
};
</script>

<style>
</style>